import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a5ffc8d8&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=a5ffc8d8&prod&lang=scss"
import style1 from "./List.vue?vue&type=style&index=1&id=a5ffc8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ffc8d8",
  null
  
)

export default component.exports